import { createSlice } from "@reduxjs/toolkit";
import { apiSlice } from "./apiSlice";
// import { jwtDecode } from 'jwt-decode';
import moment from "moment/moment";

const initialState = {
  access_token: typeof window !== "undefined" ? localStorage.getItem("access_token") || null : null,
  refresh_token: typeof window !== "undefined" ? localStorage.getItem("refresh_token") || null : null,
  user: typeof window !== 'undefined' ? (() => {
    try {
      const item = localStorage.getItem('user');
      return item ? JSON.parse(item) : null;
    } catch (error) {
      return null;
    }
  })() : null,
  expires_at: typeof window !== "undefined" ? localStorage.getItem("expires_at") || null : null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      console.log("user:>>>>>", action.payload);
      const access_token = action.payload;
      state.access_token = access_token;
      typeof window !== "undefined" &&  localStorage.setItem("access_token", access_token);
    },
    logout: (state) => {
      state.access_token = null;
      state.refresh_token = null;
      state.user = null;
      if(typeof window !== "undefined") {
        localStorage.removeItem("access_token");
        localStorage.removeItem("refresh_token");
        localStorage.removeItem("user");
      }
    },
  },
  // extraReducers: (builder) => {
  //   if (apiSlice?.endpoints?.login?.matchFulfilled) {
  //     builder.addMatcher(
  //       apiSlice.endpoints.login.matchFulfilled,
  //       (state, { payload }) => {
  //         state.access_token = payload?.data?.accessToken;
  //         state.refresh_token = payload?.data?.refreshToken;
  //         state.user = payload?.data?.user;
  //         // const expires_at = jwtDecode(payload?.data?.accessToken);
  //         // expires_at.exp = moment(expires_at?.exp * 1000).format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ');
  //         // state.expires_at = expires_at?.exp;
  //         // console.log("expires_at", expires_at?.exp);

  //         if (typeof window !== 'undefined') {
  //           localStorage.setItem("access_token", payload?.data?.accessToken);
  //           localStorage.setItem("refresh_token", payload?.data?.refreshToken);
  //           localStorage.setItem("user", JSON.stringify(payload?.data?.user));
  //           // localStorage.setItem("expires_at", expires_at?.exp);
  //         };
  //       },
  //     );
  //   } 
  //   if (apiSlice.endpoints.refreshToken.matchFulfilled) {
  //     builder.addMatcher(
  //       apiSlice.endpoints.refreshToken.matchFulfilled,
  //       (state, { payload }) => {
  //         state.access_token = payload?.data?.accessToken;
  //         const expires_at = jwtDecode(payload?.data?.accessToken);
  //         expires_at.exp = moment(expires_at?.exp * 1000).format('YYYY-MM-DDTHH:mm:ss.SSSSSSZ');
  //         state.expires_at = expires_at?.exp;
  //         if (typeof window !== 'undefined') {
  //           localStorage.setItem("access_token", payload.access_token);
  //           localStorage.setItem("expires_at", expires_at?.exp);
  //         };
  //       }
  //     );
  //   }
  //   if (apiSlice?.endpoints?.getProfile?.matchFulfilled) {
  //     builder.addMatcher(
  //       apiSlice.endpoints.getProfile.matchFulfilled,
  //       (state, { payload }) => {
  //         state.user = payload.data;

  //         if (typeof window !== 'undefined') {
  //           localStorage.setItem('user', JSON.stringify(payload.data));
  //         }
  //       }
  //     );
  //   }
  // },
});

export const { setCredentials, logout } = authSlice.actions;
export default authSlice.reducer;
